import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import "./themes/styles/themes.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import LandingPage from "./components/LandingPage.tsx";
import LoginPage from "./components/LoginPage.tsx";
import HomeScreen from "./components/HomeScreen.tsx";
import FloatingAIChat from "./components/AIAssistant/FloatingAIChat.tsx";
import ContactUs from "./components/ContactUs.tsx";
import BecomeAPartner from "./components/BecomeAPartner.tsx";
import AboutUs from "./components/AboutUs.tsx";
import PricingPage from "./components/PricingPage.tsx";
import FeaturesPage from "./components/FeaturesPage.tsx";
import SISModule from "./components/SIS/SISModule.tsx";
import HRModule from "./components/HR/HRModule.tsx";
import FinanceModule from "./components/Finance/FinanceModule.tsx";
import AcademicsModule from "./components/Academics/AcademicsModule.tsx";
import ScheduleModule from "./components/Schedule/ScheduleModule.tsx";
import TransportModule from "./components/Transport/TransportModule.tsx";
import AdmissionsModule from "./components/Admissions/AdmissionsModule.tsx";
import AnalyticsModule from "./components/Analytics/AnalyticsModule.tsx";
import CertificatesModule from "./components/Certificates/CertificatesModule.tsx";
import TicketsModule from "./components/Tickets/TicketsModule.tsx";
import LibraryModule from "./components/Library/LibraryModule.tsx";
import AIAssistant from "./components/AIAssistant/AIAssistant.tsx";
import PhotoGalleryModule from "./components/PhotoGallery/PhotoGalleryModule.tsx";

// SEO Landing Pages
import AISchoolERPIndia from "./components/SEOPages/AISchoolERPIndia.tsx";
import EducationManagementSystem from "./components/SEOPages/EducationManagementSystem.tsx";
import FeeCollectionSchoolERP from "./components/SEOPages/FeeCollectionSchoolERP.tsx";
import SchoolAdmissionManagement from "./components/SEOPages/SchoolAdmissionManagement.tsx";
import AgenticAISchoolManagement from "./components/SEOPages/AgenticAISchoolManagement.tsx";
import AIPoweredSchoolManagement from "./components/SEOPages/AIPoweredSchoolManagement.tsx";
import ERPvsAIERP from "./components/SEOPages/ERPvsAIERP.tsx";
import AIERPForCBSESchools from "./components/SEOPages/AIERPForCBSESchools.tsx";
import AIFeeCollectionPrediction from "./components/SEOPages/AIFeeCollectionPrediction.tsx";
import AIStudentPerformanceAnalytics from "./components/SEOPages/AIStudentPerformanceAnalytics.tsx";

// Helper to get the active domain (supports super user domain switching)
function getActiveDomain(): string {
  const activeDomain = localStorage.getItem('activeDomain');
  if (activeDomain) return activeDomain;
  const userData = localStorage.getItem('userData');
  if (userData) return JSON.parse(userData).domain || '';
  return '';
}

function AppContent() {
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  const handleLogin = () => {
    setLoggedIn(true);
    navigate('/dashboard');
  };

  const handleLogout = () => {
    setLoggedIn(false);
    localStorage.removeItem('activeDomain');
    navigate('/');
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <LandingPage
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
              onNavigateToPartner={() => navigate('/become-a-partner')}
              onNavigateToAbout={() => navigate('/about')}
              onNavigateToPricing={() => navigate('/pricing')}
              onNavigateToFeatures={(section?: string) => navigate(section ? `/features#${section}` : '/features')}
            />
          }
        />
        <Route
          path="/login"
          element={<LoginPage onLogin={handleLogin} />}
        />
        <Route
          path="/contact"
          element={<ContactUs onBack={() => navigate('/')} />}
        />
        <Route
          path="/become-a-partner"
          element={<BecomeAPartner onBack={() => navigate('/')} />}
        />
        <Route
          path="/about"
          element={<AboutUs onBack={() => navigate('/')} />}
        />
        <Route
          path="/pricing"
          element={<PricingPage onBack={() => navigate('/')} />}
        />
        <Route
          path="/features"
          element={
            <FeaturesPage
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        {/* SEO Landing Pages */}
        <Route
          path="/ai-school-erp-india"
          element={
            <AISchoolERPIndia
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/education-management-system"
          element={
            <EducationManagementSystem
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/fee-collection-school-erp"
          element={
            <FeeCollectionSchoolERP
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/school-admission-management-software"
          element={
            <SchoolAdmissionManagement
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/agentic-ai-school-management"
          element={
            <AgenticAISchoolManagement
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/ai-powered-school-management-software"
          element={
            <AIPoweredSchoolManagement
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/erp-vs-ai-erp"
          element={
            <ERPvsAIERP
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/ai-erp-for-cbse-schools"
          element={
            <AIERPForCBSESchools
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/ai-fee-collection-prediction"
          element={
            <AIFeeCollectionPrediction
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/ai-student-performance-analytics"
          element={
            <AIStudentPerformanceAnalytics
              onBack={() => navigate('/')}
              onNavigateToLogin={() => navigate('/login')}
              onNavigateToContact={() => navigate('/contact')}
            />
          }
        />
        <Route
          path="/dashboard"
          element={
            loggedIn ? (
              <HomeScreen onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/sis/*"
          element={
            loggedIn ? (
              <SISModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/hr/*"
          element={
            loggedIn ? (
              <HRModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/finance/*"
          element={
            loggedIn ? (
              <FinanceModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/academics/*"
          element={
            loggedIn ? (
              <AcademicsModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/schedule/*"
          element={
            loggedIn ? (
              <ScheduleModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/transport/*"
          element={
            loggedIn ? (
              <TransportModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/admissions/*"
          element={
            loggedIn ? (
              <AdmissionsModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/analytics/*"
          element={
            loggedIn ? (
              <AnalyticsModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/certificates/*"
          element={
            loggedIn ? (
              <CertificatesModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/library/*"
          element={
            loggedIn ? (
              <LibraryModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/tickets/*"
          element={
            loggedIn ? (
              <TicketsModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/ai-assistant"
          element={
            loggedIn ? (
              <AIAssistant domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/photo-gallery/*"
          element={
            loggedIn ? (
              <PhotoGalleryModule domain={getActiveDomain()} onBack={() => navigate('/dashboard')} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>

      {/* AI Chat available on all dashboard pages when logged in */}
      {loggedIn && (
        <FloatingAIChat
          domain={getActiveDomain()}
        />
      )}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
